import { computed } from 'vue'
import { useStore } from '@/composables/useStore.ts'
import { brandings } from '@/config/brandings/index.js'
import { DEFAULT_BRANDING } from '@/config/constants.ts'
import type { AppBranding } from '@/types/store/models/school'

export function useBranding() {
  const { store } = useStore()

  const publicPath = computed(() => {
    return import.meta.env.BASE_URL
  })

  const branding = computed(() => {
    return store.getters['schoolBranding/getBranding']
  })

  const brandingConfig = computed(() => {
    return store.getters['schoolBranding/getBrandingConfig']
  })

  const brandingKeys = computed(() => {
    return Object.keys(brandings)
  })

  const getImage = (image: string): string => {
    return publicPath.value + image
  }

  const getBrandedUrl = (path: string, explicitBranding?: AppBranding): string => {
    const url = new URL(path, import.meta.env.VITE_LIVE_UPDATE_ENABLED === 'true' ? import.meta.env.VITE_APP_URL : location.origin)
    const currentBranding = explicitBranding || branding.value

    if (branding.value === DEFAULT_BRANDING) return url.href

    url.searchParams.append('branding', currentBranding)

    return url.href
  }

  return {
    publicPath,
    branding,
    brandingConfig,
    brandingKeys,
    getImage,
    getBrandedUrl
  }
}
